module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title142"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781466815902_tp01",
      "id": "toctitle139",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_forewordPage",
    attrs: {
      "href": "#/e9781466815902_frw01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Foreword")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781466815902_fm01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Preface")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781466815902_fm02",
      "id": "toctitle135"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Basics")])])]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c01",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("MUFFINS AND SCONES")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title4",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blueberry Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title5",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Carrot Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title6",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mincemeat Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title7",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Mocha Pecan Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title8",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Orange Poppy Seed Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title9",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Banana Chocolate Chip Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title10",
      "id": "toctitle10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rhubarb Crumb Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title11",
      "id": "toctitle11"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double Berry Crumb Muffins")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title12",
      "id": "toctitle12"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Oatmeal Scones")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title13",
      "id": "toctitle13"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Scott’s Drop Scones")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title14",
      "id": "toctitle14"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ginger Scones")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c01#title15",
      "id": "toctitle15"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apricot Ginger Scones")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c02",
      "id": "toctitle16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("POUND CAKES AND BREADS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title17",
      "id": "toctitle17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sour Cream Pound Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Peanut Butter Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title19",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Pound Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title20",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lemon Pound Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title21",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Corn Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Date Nut Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title23",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Anadama Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title24",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Zvi’s Cinnamon Swirl Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c02#title25",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Squash Rolls")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c03",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("COOKIES AND BARS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title27",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cappuccino Shortbread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title28",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Polish Tea Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title29",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ginger Hearts")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title30",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Chip Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title31",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fruited Biscotti")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title32",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Biscotti")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title33",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Old-Fashioned Soft Sugar Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title34",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Persimmon Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title35",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flourless Peanut Butter Chocolate Chunk Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title36",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chuckies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title37",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double Peanut Chocolate Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title38",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Italian Sesame Seed Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title39",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double Chocolate Almond Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title40",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Orange and Oat Chewies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title41",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Nutella Shortbread Sandwich Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title42",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Toffee Pecan Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title43",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Double Chocolate Mint Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title44",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Jumbles")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title45",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Simple Lemon Wafers")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title46",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("My Favorite Cutout Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title47",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gorp Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title48",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Mint Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title49",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Beach Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title50",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Kara’s Blondie Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title51",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("White Chocolate Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title52",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Raspberry Squares")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title53",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Magic Bars")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title54",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dot’s Lemon Bars")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title55",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cream Cheese Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title56",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hermits")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title57",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Passover Brownies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c03#title58",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Peanut Butter Squares")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c04",
      "id": "toctitle59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PIES, CRISPS, AND COBBLERS")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title60",
      "id": "toctitle60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Pear Crisp")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title61",
      "id": "toctitle61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rhubarb Cobbler")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title62",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Tart Pastry")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title63",
      "id": "toctitle63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rhubarb Tart")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title64",
      "id": "toctitle64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Buttermilk Pie Crust")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title65",
      "id": "toctitle65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Nancy Hardy’s Pecan Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title66",
      "id": "toctitle66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apricot Cherry Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title67",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Peach Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title68",
      "id": "toctitle68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Open-Faced Fresh Blueberry Tart")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title69",
      "id": "toctitle69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rhubarb Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title70",
      "id": "toctitle70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Wafer Cookie Crust")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title71",
      "id": "toctitle71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Crème de Menthe Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title72",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gingersnap Crumb Crust")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title73",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lemon Cream Cheese Tart")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title74",
      "id": "toctitle74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apple Cream Cheese Tart")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title75",
      "id": "toctitle75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blueberry Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title76",
      "id": "toctitle76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sweet Potato Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title77",
      "id": "toctitle77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apricot Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title78",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Peanut Butter Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title79",
      "id": "toctitle79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Graham Cracker Crust")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title80",
      "id": "toctitle80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Key Lime Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title81",
      "id": "toctitle81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Pumpkin Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title82",
      "id": "toctitle82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apple Crumb Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title83",
      "id": "toctitle83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Strawberry Rhubarb Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title84",
      "id": "toctitle84",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sour Cherry Pie")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title85",
      "id": "toctitle85",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Homemade Mincemeat")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title86",
      "id": "toctitle86",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Orange Moss")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title87",
      "id": "toctitle87",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fresh Blueberry and White Chocolate Tart")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title88",
      "id": "toctitle88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apple Cranberry Crisp")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c04#title89",
      "id": "toctitle89",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blueberry Crisp")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c05",
      "id": "toctitle90",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("CAKES")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title91",
      "id": "toctitle91",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("No Citron Fruit Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title92",
      "id": "toctitle92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Carrot Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title93",
      "id": "toctitle93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cream Cheese Icing")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title94",
      "id": "toctitle94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Yellow Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title95",
      "id": "toctitle95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Icing")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title96",
      "id": "toctitle96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cheesecake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title97",
      "id": "toctitle97",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Mousse Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title98",
      "id": "toctitle98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hummingbird Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title99",
      "id": "toctitle99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Devil’s Food Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title100",
      "id": "toctitle100",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flourless Chocolate Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title101",
      "id": "toctitle101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Raspberry Sauce")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title102",
      "id": "toctitle102",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Whipped Cream")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title103",
      "id": "toctitle103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Chocolate Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title104",
      "id": "toctitle104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("German Chocolate Cake Frosting")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title105",
      "id": "toctitle105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Fudge Cupcakes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title106",
      "id": "toctitle106",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Peanut Butter Icing")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title107",
      "id": "toctitle107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Chip Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title108",
      "id": "toctitle108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Apple Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title109",
      "id": "toctitle109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Warm Individual Chocolate Cakes")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title110",
      "id": "toctitle110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Raspberry Charlotte")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title111",
      "id": "toctitle111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gingerbread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title112",
      "id": "toctitle112",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Almond Butter Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title113",
      "id": "toctitle113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Raspberry Blueberry Filling")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title114",
      "id": "toctitle114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sour Cream Coffee Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title115",
      "id": "toctitle115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Lime Mousse Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title116",
      "id": "toctitle116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Hazelnut Fudge Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title117",
      "id": "toctitle117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cranberry Crumb Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title118",
      "id": "toctitle118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bob’s Mud Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title119",
      "id": "toctitle119",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chocolate Water Glaze")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title120",
      "id": "toctitle120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Tres Leches Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title121",
      "id": "toctitle121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blueberry Buckle")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title122",
      "id": "toctitle122",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sticky Toffee Date Pudding")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title123",
      "id": "toctitle123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Coconut Birthday Cake")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c05#title124",
      "id": "toctitle124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Nanny Ethel’s Kugel")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781466815902_c06",
      "id": "toctitle125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HEALTHY ALTERNATIVES")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title126",
      "id": "toctitle126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Energy Bars")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title127",
      "id": "toctitle127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Whole Wheat Quick Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title128",
      "id": "toctitle128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Healthy Pumpkin Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title129",
      "id": "toctitle129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sunflower Whole Wheat Quick Bread")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title130",
      "id": "toctitle130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("My Favorite Oatmeal Cereal")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title131",
      "id": "toctitle131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Rena’s Sport Bars")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title132",
      "id": "toctitle132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Oatmeal Tahini Cookies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title133",
      "id": "toctitle133",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Healthy Bran Muffins")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781466815902_c06#title134",
      "id": "toctitle134",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Multigrain Muffins")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781466815902_ack01",
      "id": "toctitle136",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781466815902_als01",
      "id": "toctitle137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ALSO BY KATHLEEN KING")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_index",
    attrs: {
      "href": "#/e9781466815902_ind01",
      "id": "toctitle138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Index")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781466815902_cop01",
      "id": "toctitle140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cfce78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466815902_toc01.vue
// module id = 63
// module chunks = 0